import { useState } from "react";
import { usePath } from "../libs/path/PathProvider";
import GTextSelect from "../libs/textfield/GTextSelect";
import { ISelectRow } from "../libs/dropdown/Dropdown";
import Foods from "../data/Foods";
import { combineClass } from "../libs/GWidget";

export interface IFoodSearchProps {
    className:string
    onSearch:(id:number) => void
}
export default function FoodSearch(props:IFoodSearchProps){
    const Options : ISelectRow<number>[] = Foods.i.cache!.map(food => ({value:food._id, label:food.name}))
    function id2option(id:number|string){
        return Options.find(o => o.value==id)
    }

    const {path} = usePath()
    const [selected,setSelected] = useState<ISelectRow<number>|undefined>(id2option(path.split("/")[2]))

    const onSelect = (e:any, food:ISelectRow<number>|null) => {
        if (!food) return
        else props.onSearch(food.value)
        setSelected(food)
    }

    return <div className={combineClass("search",props.className)}>
        <GTextSelect options={Options} onChange={onSelect} value={selected} defaultValue={selected} placeholder="Search"/>
    </div>
}